import { Outlet } from "react-router-dom"
import Sidebar from "../Sidebar"
import Footer from "../Footer"
import Seo from "../Seo"
import "./index.scss"

const Layout = () => {
  return (
    <div className="App">
      <Seo />
      <Sidebar />
      <div className="page">
        <span className="tags top-tags">&lt;body&gt;</span>

        <main className="page-content" aria-label="Main content">
          <Outlet />
        </main>

        <span className="tags bottom-tags">
          &lt;/body&gt;
          <br />
          <span className="bottom-tag-html">&lt;/html&gt;</span>
        </span>

        <Footer />
      </div>
    </div>
  )
}

export default Layout
